/*
* File:        jquery.dataTables.columnFilter.js
* Version:     1.5.0.
* Author:      Jovan Popovic 
* http://jquery-datatables-column-filter.googlecode.com/svn/trunk/index.htmls
* http://code.google.com/p/jquery-datatables-column-filter/
* 
* Copyright 2011-2012 Jovan Popovic, all rights reserved.
*
* This source file is free software, under either the GPL v2 license or a
* BSD style license, as supplied with this software.
* 
* This source file is distributed in the hope that it will be useful, but 
* WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY 
* or FITNESS FOR A PARTICULAR PURPOSE. 
* 
* Parameters:"
* @sPlaceHolder                 String      Place where inline filtering function should be placed ("tfoot", "thead:before", "thead:after"). Default is "tfoot"
* @sRangeSeparator              String      Separator that will be used when range values are sent to the server-side. Default value is "~".
* @sRangeFormat                 string      Default format of the From ... to ... range inputs. Default is From {from} to {to}
* @aoColumns                    Array       Array of the filter settings that will be applied on the columns
*/
(function ($) {


    $.fn.columnFilter = function (options) {

        var asInitVals, i, label, th;

        //var sTableId = "table";
        var sRangeFormat = "From {from} to {to}";
        //Array of the functions that will override sSearch_ parameters
        var afnSearch_ = new Array();
        var aiCustomSearch_Indexes = new Array();

        var oFunctionTimeout = null;

        var fnOnFiltered = function () { };

        function _fnGetColumnValues(oSettings, iColumn, bUnique, bFiltered, bIgnoreEmpty) {
            ///<summary>
            ///Return values in the column
            ///</summary>
            ///<param name="oSettings" type="Object">DataTables settings</param>
            ///<param name="iColumn" type="int">Id of the column</param>
            ///<param name="bUnique" type="bool">Return only distinct values</param>
            ///<param name="bFiltered" type="bool">Return values only from the filtered rows</param>
            ///<param name="bIgnoreEmpty" type="bool">Ignore empty cells</param>

            // check that we have a column id
            if (typeof iColumn == "undefined") return new Array();

            // by default we only wany unique data
            if (typeof bUnique == "undefined") bUnique = true;

            // by default we do want to only look at filtered data
            if (typeof bFiltered == "undefined") bFiltered = true;

            // by default we do not wany to include empty values
            if (typeof bIgnoreEmpty == "undefined") bIgnoreEmpty = true;

            // list of rows which we're going to loop through
            var aiRows;

            // use only filtered rows
            if (bFiltered == true) aiRows = oSettings.aiDisplay;
            // use all rows
            else aiRows = oSettings.aiDisplayMaster; // all row numbers

            // set up data array    
            var asResultData = new Array();

            for (var i = 0, c = aiRows.length; i < c; i++) {
                var iRow = aiRows[i];
                var aData = oTable.fnGetData(iRow);
                var sValue = aData[iColumn];

                // ignore empty values?
                if (bIgnoreEmpty == true && sValue.length == 0) continue;

                // ignore unique values?
                else if (bUnique == true && jQuery.inArray(sValue, asResultData) > -1) continue;

                // else push the value onto the result data array
                else asResultData.push(sValue);
            }

            return asResultData.sort();
        }

        function _fnColumnIndex(iColumnIndex) {
            if (properties.bUseColVis)
                return iColumnIndex;
            else
                return oTable.fnSettings().oApi._fnVisibleToColumnIndex(oTable.fnSettings(), iColumnIndex);
            //return iColumnIndex;
            //return oTable.fnSettings().oApi._fnColumnIndexToVisible(oTable.fnSettings(), iColumnIndex);
        }

        function fnCreateInput(oTable, regex, smart, bIsNumber, iFilterLength, iMaxLenght) {
            var sCSSClass = "text_filter";
            if (bIsNumber)
                sCSSClass = "number_filter";

            label = label.replace(/(^\s*)|(\s*$)/g, "");
            var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
            var search_init = 'search_init ';
            var inputvalue = label;
            if (currentFilter != '' && currentFilter != '^') {
                if (bIsNumber && currentFilter.charAt(0) == '^')
                    inputvalue = currentFilter.substr(1); //ignore trailing ^
                else
                    inputvalue = currentFilter;
                search_init = '';
            }

            var input = $('<input type="text" class="' + search_init + sCSSClass + '" value="' + inputvalue + '"/>');
            if (iMaxLenght != undefined && iMaxLenght != -1) {
                input.attr('maxlength', iMaxLenght);
            }
            th.html(input);
            if (bIsNumber)
                th.wrapInner('<span class="filter_column filter_number" />');
            else
                th.wrapInner('<span class="filter_column filter_text" />');

            asInitVals[i] = label;
            var index = i;

            if (bIsNumber && !oTable.fnSettings().oFeatures.bServerSide) {
                input.keyup(function () {
                    /* Filter on the column all numbers that starts with the entered value */
                    oTable.fnFilter('^' + this.value, _fnColumnIndex(index), true, false); //Issue 37
                    fnOnFiltered();
                });
            } else {
                input.keyup(function () {
                    if (oTable.fnSettings().oFeatures.bServerSide && iFilterLength != 0) {
                        //If filter length is set in the server-side processing mode
                        //Check has the user entered at least iFilterLength new characters

                        var currentFilter = oTable.fnSettings().aoPreSearchCols[index].sSearch;
                        var iLastFilterLength = $(this).data("dt-iLastFilterLength");
                        if (typeof iLastFilterLength == "undefined")
                            iLastFilterLength = 0;
                        var iCurrentFilterLength = this.value.length;
                        if (Math.abs(iCurrentFilterLength - iLastFilterLength) < iFilterLength
                        //&& currentFilter.length == 0 //Why this?
                            ) {
                            //Cancel the filtering
                            return;
                        }
                        else {
                            //Remember the current filter length
                            $(this).data("dt-iLastFilterLength", iCurrentFilterLength);
                        }
                    }
                    /* Filter on the column (the index) of this element */
                    oTable.fnFilter(this.value, _fnColumnIndex(index), regex, smart); //Issue 37
                    fnOnFiltered();
                });
            }

            input.focus(function () {
                if ($(this).hasClass("search_init")) {
                    $(this).removeClass("search_init");
                    this.value = "";
                }
            });
            input.blur(function () {
                if (this.value == "") {
                    $(this).addClass("search_init");
                    this.value = asInitVals[index];
                }
            });
        }

        function fnCreateRangeInput(oTable) {

            //var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
            th.html(_fnRangeLabelPart(0));
            var sFromId = oTable.attr("id") + '_range_from_' + i;
            var from = $('<input type="text" class="number_range_filter" id="' + sFromId + '" rel="' + i + '"/>');
            th.append(from);
            th.append(_fnRangeLabelPart(1));
            var sToId = oTable.attr("id") + '_range_to_' + i;
            var to = $('<input type="text" class="number_range_filter" id="' + sToId + '" rel="' + i + '"/>');
            th.append(to);
            th.append(_fnRangeLabelPart(2));
            th.wrapInner('<span class="filter_column filter_number_range" />');
            var index = i;
            aiCustomSearch_Indexes.push(i);



            //------------start range filtering function


            /*  Custom filtering function which will filter data in column four between two values
            *   Author:     Allan Jardine, Modified by Jovan Popovic
            */
            //$.fn.dataTableExt.afnFiltering.push(
            oTable.dataTableExt.afnFiltering.push(
            function (oSettings, aData, iDataIndex) {
                if (oTable.attr("id") != oSettings.sTableId)
                    return true;
                // Try to handle missing nodes more gracefully
                if (document.getElementById(sFromId) == null)
                    return true;
                var iMin = document.getElementById(sFromId).value * 1;
                var iMax = document.getElementById(sToId).value * 1;
                var iValue = aData[_fnColumnIndex(index)] == "-" ? 0 : aData[_fnColumnIndex(index)] * 1;
                if (iMin == "" && iMax == "") {
                    return true;
                }
                else if (iMin == "" && iValue <= iMax) {
                    return true;
                }
                else if (iMin <= iValue && "" == iMax) {
                    return true;
                }
                else if (iMin <= iValue && iValue <= iMax) {
                    return true;
                }
                return false;
            }
        );
            //------------end range filtering function



            $('#' + sFromId + ',#' + sToId, th).keyup(function () {

                var iMin = document.getElementById(sFromId).value * 1;
                var iMax = document.getElementById(sToId).value * 1;
                if (iMin != 0 && iMax != 0 && iMin > iMax)
                    return;

                oTable.fnDraw();
                fnOnFiltered();
            });


        }


        function fnCreateDateRangeInput(oTable) {

            var aoFragments = sRangeFormat.split(/[}{]/);

            th.html("");
            //th.html(_fnRangeLabelPart(0));
            var sFromId = oTable.attr("id") + '_range_from_' + i;
            var from = $('<input type="text" placeholder="From" class="date_range_filter" style="margin-bottom:2px;" id="' + sFromId + '" rel="' + i + '"/>');
            from.datepicker();
            //th.append(from);
            //th.append(_fnRangeLabelPart(1));
            var sToId = oTable.attr("id") + '_range_to_' + i;
            var to = $('<input type="text" placeholder="To" class="date_range_filter" id="' + sToId + '" rel="' + i + '"/>');
            //th.append(to);
            //th.append(_fnRangeLabelPart(2));

            for (ti = 0; ti < aoFragments.length; ti++) {
                if (aoFragments[ti] == properties.sDateFromToken) {
                    th.append(from);
                } else {
                    if (aoFragments[ti] == properties.sDateToToken) {
                        th.append(to);
                    } else {
                        th.append(aoFragments[ti]);
                    }
                }
                

            }


            th.wrapInner('<span class="filter_column filter_date_range" />');
            to.datepicker();
            var index = i;
            aiCustomSearch_Indexes.push(i);


            //------------start date range filtering function

            //$.fn.dataTableExt.afnFiltering.push(
            oTable.dataTableExt.afnFiltering.push(
            function (oSettings, aData, iDataIndex) {
                if (oTable.attr("id") != oSettings.sTableId)
                    return true;

                var dStartDate = from.datepicker("getDate");

                var dEndDate = to.datepicker("getDate");

                if (dStartDate == null && dEndDate == null) {
                    return true;
                }

                var dCellDate = null;
                try {
                    if (aData[_fnColumnIndex(index)] == null || aData[_fnColumnIndex(index)] == "")
                        return false;
                    dCellDate = $.datepicker.parseDate(from.datepicker("option", "dateFormat"), aData[_fnColumnIndex(index)]);
                } catch (ex) {
                    console.log(ex);
                    return false;
                }
                if (dCellDate == null)
                    return false;

                
                if (dStartDate == null && dCellDate <= dEndDate) {
                    return true;
                }
                else if (dStartDate <= dCellDate && dEndDate == null) {
                    return true;
                }
                else if (dStartDate <= dCellDate && dCellDate <= dEndDate) {
                    return true;
                }
                return false;
            }
        );
            //------------end date range filtering function

            $('#' + sFromId + ',#' + sToId, th).change(function () {
                oTable.fnDraw();
                fnOnFiltered();
            });


        }

        function fnCreateColumnSelect(oTable, aData, iColumn, nTh, sLabel, bRegex, oSelected, bCaseSensitive) {
            bCaseSensitive = (typeof bCaseSensitive !== 'undefined') ? !bCaseSensitive : true;
            if (aData == null)
                aData = _fnGetColumnValues(oTable.fnSettings(), iColumn, true, false, true);
            var index = iColumn;
            var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
            if (currentFilter == null || currentFilter == "")//Issue 81
                currentFilter = oSelected;

            var r = '<select class="search_init select_filter"><option value="" class="search_init">' + sLabel + '</option>';
            var j = 0;
            var iLen = aData.length;
            for (j = 0; j < iLen; j++) {
                if (typeof (aData[j]) != 'object') {
                    var selected = '';
                    if (escape(aData[j]) == currentFilter
                        || escape(aData[j]) == escape(currentFilter)
                        )
                        selected = 'selected '
                    r += '<option ' + selected + ' value="' + escape(aData[j]) + '">' + aData[j] + '</option>';
                }
                else {
                    var selected = '';
                    if (bRegex) {
                        //Do not escape values if they are explicitely set to avoid escaping special characters in the regexp
                        if (aData[j].value == currentFilter) selected = 'selected ';
                        r += '<option ' + selected + 'value="' + aData[j].value + '">' + aData[j].label + '</option>';
                    } else {
                        if (escape(aData[j].value) == currentFilter) selected = 'selected ';
                        r += '<option ' + selected + 'value="' + escape(aData[j].value) + '">' + aData[j].label + '</option>';
                    }
                }
            }

            var select = $(r + '</select>');
            nTh.html(select);
            nTh.wrapInner('<span class="filter_column filter_select" />');
            select.change(function () {
                //var val = $(this).val();
                if ($(this).val() != "") {
                    $(this).removeClass("search_init");
                } else {
                    $(this).addClass("search_init");
                }
                if (bRegex)
                    oTable.fnFilter($(this).val(), iColumn, bRegex, true, true, bCaseSensitive); //Issue 41
                else
                    oTable.fnFilter(unescape($(this).val()), iColumn, bRegex, true, true, bCaseSensitive); //Issue 25
                fnOnFiltered();
            });
            if (currentFilter != null && currentFilter != "")//Issue 81
                oTable.fnFilter(unescape(currentFilter), iColumn);
        }

        function fnCreateSelect(oTable, aData, bRegex, oSelected, bCaseSensitive) {
            var oSettings = oTable.fnSettings();
            if (aData == null && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
                // Add a function to the draw callback, which will check for the Ajax data having 
                // been loaded. Use a closure for the individual column elements that are used to 
                // built the column filter, since 'i' and 'th' (etc) are locally "global".
                oSettings.aoDrawCallback.push({
                    "fn": (function (iColumn, nTh, sLabel) {
                        return function () {
                            // Only rebuild the select on the second draw - i.e. when the Ajax
                            // data has been loaded.
                            if (oSettings.iDraw == 2 && oSettings.sAjaxSource != null && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
                                return fnCreateColumnSelect(oTable, null, _fnColumnIndex(iColumn), nTh, sLabel, bRegex, oSelected); //Issue 37
                            }
                        };
                    })(i, th, label),
                    "sName": "column_filter_" + i
                });
            }
            // Regardless of the Ajax state, build the select on first pass
            fnCreateColumnSelect(oTable, aData, _fnColumnIndex(i), th, label, bRegex, oSelected, bCaseSensitive); //Issue 37

        }

        function fnCreateCheckbox(oTable, aData) {

            if (aData == null)
                aData = _fnGetColumnValues(oTable.fnSettings(), i, true, true, true);
            var index = i;

            var r = '', j, iLen = aData.length;

            //clean the string
            var localLabel = label.replace('%', 'Perc').replace("&", "AND").replace("$", "DOL").replace("£", "STERL").replace("@", "AT").replace(/\s/g, "_");
            localLabel = localLabel.replace(/[^a-zA-Z 0-9]+/g, '');
            //clean the string

            //button label override
            var labelBtn = label;
            if (properties.sFilterButtonText != null || properties.sFilterButtonText != undefined) {
                labelBtn = properties.sFilterButtonText;
            }

            var relativeDivWidthToggleSize = 10;
            var numRow = 12; //numero di checkbox per colonna
            var numCol = Math.floor(iLen / numRow);
            if (iLen % numRow > 0) {
                numCol = numCol + 1;
            };

            //count how many column should be generated and split the div size
            var divWidth = 100 / numCol - 2;

            var divWidthToggle = relativeDivWidthToggleSize * numCol;

            if (numCol == 1) {
                divWidth = 20;
            }

            var divRowDef = '<div style="float:left; min-width: ' + divWidth + '%; " >';
            var divClose = '</div>';

            var uniqueId = oTable.attr("id") + localLabel;
            var buttonId = "chkBtnOpen" + uniqueId;
            var checkToggleDiv = uniqueId + "-flt-toggle";
            r += '<button id="' + buttonId + '" class="checkbox_filter" > ' + labelBtn + '</button>'; //filter button witch open dialog
            r += '<div id="' + checkToggleDiv + '" '
                + 'title="' + label + '" '
                + 'class="toggle-check ui-widget-content ui-corner-all"  style="width: ' + (divWidthToggle) + '%; " >'; //dialog div
            //r+= '<div align="center" style="margin-top: 5px; "> <button id="'+buttonId+'Reset" class="checkbox_filter" > reset </button> </div>'; //reset button and its div
            r += divRowDef;

            for (j = 0; j < iLen; j++) {

                //if last check close div
                if (j % numRow == 0 && j != 0) {
                    r += divClose + divRowDef;
                }

                //check button
                r += '<input class="search_init checkbox_filter" type="checkbox" id= "' + aData[j] + '" name= "' + localLabel + '" value="' + aData[j] + '" >' + aData[j] + '<br/>';

                var checkbox = $(r);
                th.html(checkbox);
                th.wrapInner('<span class="filter_column filter_checkbox" />');
                //on every checkbox selection
                checkbox.change(function () {

                    var search = '';
                    var or = '|'; //var for select checks in 'or' into the regex
                    var resSize = $('input:checkbox[name="' + localLabel + '"]:checked').size();
                    $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index) {

                        //search = search + ' ' + $(this).val();
                        //concatenation for selected checks in or
                        if ((index == 0 && resSize == 1)
                                || (index != 0 && index == resSize - 1)) {
                            or = '';
                        }
                        //trim
                        search = search.replace(/^\s+|\s+$/g, "");
                        search = search + $(this).val() + or;
                        or = '|';

                    });

                    for (var jj = 0; jj < iLen; jj++) {
                        if (search != "") {
                            $('#' + aData[jj]).removeClass("search_init");
                        } else {
                            $('#' + aData[jj]).addClass("search_init");
                        }
                    }

                    //execute search
                    oTable.fnFilter(search, index, true, false);
                    fnOnFiltered();
                });
            }

            //filter button
            $('#' + buttonId).button();
            //dialog
            $('#' + checkToggleDiv).dialog({
                //height: 140,
                autoOpen: false,
                //show: "blind",
                hide: "blind",
                buttons: [{
                    text: "Reset",
                    click: function () {
                        //$('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
                        $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index3) {
                            $(this).attr('checked', false);
                            $(this).addClass("search_init");
                        });
                        oTable.fnFilter('', index, true, false);
                        fnOnFiltered();
                        return false;
                    }
                },
                            {
                                text: "Close",
                                click: function () { $(this).dialog("close"); }
                            }
                        ]
            });


            $('#' + buttonId).click(function () {

                $('#' + checkToggleDiv).dialog('open');
                var target = $(this);
                $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
                    at: 'bottom',
                    of: target
                });

                return false;
            });

            var fnOnFilteredCurrent = fnOnFiltered;

            fnOnFiltered = function () {
                var target = $('#' + buttonId);
                $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
                    at: 'bottom',
                    of: target
                });
                fnOnFilteredCurrent();
            };
            //reset
            /*
            $('#'+buttonId+"Reset").button();
            $('#'+buttonId+"Reset").click(function(){
            $('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
            $('input:checkbox[name="'+localLabel+'"]:checked').each(function(index3) {
            $(this).attr('checked', false);
            $(this).addClass("search_init");
            });
            oTable.fnFilter('', index, true, false);
            return false;
            }); 
            */
        }




        function _fnRangeLabelPart(iPlace) {
            switch (iPlace) {
                case 0:
                    return sRangeFormat.substring(0, sRangeFormat.indexOf("{from}"));
                case 1:
                    return sRangeFormat.substring(sRangeFormat.indexOf("{from}") + 6, sRangeFormat.indexOf("{to}"));
                default:
                    return sRangeFormat.substring(sRangeFormat.indexOf("{to}") + 4);
            }
        }




        var oTable = this;

        var defaults = {
            sPlaceHolder: "foot",
            sRangeSeparator: "~",
            iFilteringDelay: 500,
            aoColumns: null,
            sRangeFormat: "From {from} to {to}",
            sDateFromToken: "from",
            sDateToToken: "to"
        };

        var properties = $.extend(defaults, options);

        return this.each(function () {

            if (!oTable.fnSettings().oFeatures.bFilter)
                return;
            asInitVals = new Array();

            var aoFilterCells = oTable.fnSettings().aoFooter[0];

            var oHost = oTable.fnSettings().nTFoot; //Before fix for ColVis
            var sFilterRow = "tr"; //Before fix for ColVis

            if (properties.sPlaceHolder == "head:after") {
                var tr = $("tr:first", oTable.fnSettings().nTHead).detach();
                //tr.appendTo($(oTable.fnSettings().nTHead));
                if (oTable.fnSettings().bSortCellsTop) {
                    tr.prependTo($(oTable.fnSettings().nTHead));
                    //tr.appendTo($("thead", oTable));
                    aoFilterCells = oTable.fnSettings().aoHeader[1];
                }
                else {
                    tr.appendTo($(oTable.fnSettings().nTHead));
                    //tr.prependTo($("thead", oTable));
                    aoFilterCells = oTable.fnSettings().aoHeader[0];
                }

                sFilterRow = "tr:last";
                oHost = oTable.fnSettings().nTHead;

            } else if (properties.sPlaceHolder == "head:before") {

                if (oTable.fnSettings().bSortCellsTop) {
                    var tr = $("tr:first", oTable.fnSettings().nTHead).detach();
                    tr.appendTo($(oTable.fnSettings().nTHead));
                    aoFilterCells = oTable.fnSettings().aoHeader[1];
                } else {
                    aoFilterCells = oTable.fnSettings().aoHeader[0];
                }
                /*else {
                //tr.prependTo($("thead", oTable));
                sFilterRow = "tr:first";
                }*/

                sFilterRow = "tr:first";

                oHost = oTable.fnSettings().nTHead;

                
            }

            //$(sFilterRow + " th", oHost).each(function (index) {//bug with ColVis
            $(aoFilterCells).each(function (index) {//fix for ColVis
                i = index;
                var aoColumn = { type: "text",
                    bRegex: false,
                    bSmart: true,
                    iMaxLenght: -1,
                    iFilterLength: 0
                };
                if (properties.aoColumns != null) {
                    if (properties.aoColumns.length < i || properties.aoColumns[i] == null)
                        return;
                    aoColumn = properties.aoColumns[i];
                }
                //label = $(this).text(); //Before fix for ColVis
                label = $($(this)[0].cell).text(); //Fix for ColVis
                if (aoColumn.sSelector == null) {
                    //th = $($(this)[0]);//Before fix for ColVis
                    th = $($(this)[0].cell); //Fix for ColVis
                }
                else {
                    th = $(aoColumn.sSelector);
                    if (th.length == 0)
                        th = $($(this)[0].cell);
                }

                if (aoColumn != null) {
                    if (aoColumn.sRangeFormat != null)
                        sRangeFormat = aoColumn.sRangeFormat;
                    else
                        sRangeFormat = properties.sRangeFormat;
                    switch (aoColumn.type) {
                        case "null":
                            break;
                        case "number":
                            fnCreateInput(oTable, true, false, true, aoColumn.iFilterLength, aoColumn.iMaxLenght);
                            break;
                        case "select":
                            if (aoColumn.bRegex != true)
                                aoColumn.bRegex = false;
                            fnCreateSelect(oTable, aoColumn.values, aoColumn.bRegex, aoColumn.selected, aoColumn.bCaseSensitive);
                            break;
                        case "number-range":
                            fnCreateRangeInput(oTable);
                            break;
                        case "date-range":
                            fnCreateDateRangeInput(oTable);
                            break;
                        case "checkbox":
                            fnCreateCheckbox(oTable, aoColumn.values);
                            break;
                        case "text":
                        default:
                            bRegex = (aoColumn.bRegex == null ? false : aoColumn.bRegex);
                            bSmart = (aoColumn.bSmart == null ? false : aoColumn.bSmart);
                            fnCreateInput(oTable, bRegex, bSmart, false, aoColumn.iFilterLength, aoColumn.iMaxLenght);
                            break;

                    }
                }
            });

            for (j = 0; j < aiCustomSearch_Indexes.length; j++) {
                //var index = aiCustomSearch_Indexes[j];
                var fnSearch_ = function () {
                    var id = oTable.attr("id");
                    return $("#" + id + "_range_from_" + aiCustomSearch_Indexes[j]).val() + properties.sRangeSeparator + $("#" + id + "_range_to_" + aiCustomSearch_Indexes[j]).val()
                }
                afnSearch_.push(fnSearch_);
            }

            if (oTable.fnSettings().oFeatures.bServerSide) {

                var fnServerDataOriginal = oTable.fnSettings().fnServerData;

                oTable.fnSettings().fnServerData = function (sSource, aoData, fnCallback) {

                    for (j = 0; j < aiCustomSearch_Indexes.length; j++) {
                        var index = aiCustomSearch_Indexes[j];

                        for (k = 0; k < aoData.length; k++) {
                            if (aoData[k].name == "sSearch_" + index)
                                aoData[k].value = afnSearch_[j]();
                        }
                    }
                    aoData.push({ "name": "sRangeSeparator", "value": properties.sRangeSeparator });

                    if (fnServerDataOriginal != null) {
                        try {
                            fnServerDataOriginal(sSource, aoData, fnCallback, oTable.fnSettings()); //TODO: See Issue 18
                        } catch (ex) {
                            fnServerDataOriginal(sSource, aoData, fnCallback);
                        }
                    }
                    else {
                        $.getJSON(sSource, aoData, function (json) {
                            fnCallback(json)
                        });
                    }
                };

            }

        });

    };




})(jQuery);



/*!
FixedHeader 2.1.2
Â©2010-2014 SpryMedia Ltd - datatables.net/license
*/
var FixedHeader;
(function (j, k, h) {
    var l = function (e) {
        FixedHeader = function (a, b) {
            if (!this instanceof FixedHeader) alert("FixedHeader warning: FixedHeader must be initialised with the 'new' keyword."); else {
                var c = { aoCache: [], oSides: { top: !0, bottom: !1, left: 0, right: 0 }, oZIndexes: { top: 104, bottom: 103, left: 102, right: 101 }, oCloneOnDraw: { top: !1, bottom: !1, left: !0, right: !0 }, oMes: { iTableWidth: 0, iTableHeight: 0, iTableLeft: 0, iTableRight: 0, iTableTop: 0, iTableBottom: 0 }, oOffset: { top: 0 }, nTable: null, bFooter: !1, bInitComplete: !1 }; this.fnGetSettings =
function () { return c }; this.fnUpdate = function () { this._fnUpdateClones(); this._fnUpdatePositions() }; this.fnPosition = function () { this._fnUpdatePositions() }; var d = e.fn.dataTable.Api ? (new e.fn.dataTable.Api(a)).settings()[0] : a.fnSettings(); d._oPluginFixedHeader = this; this.fnInit(d, b)
            } 
        }; FixedHeader.prototype = { fnInit: function (a, b) {
            var c = this.fnGetSettings(), d = this; this.fnInitSettings(c, b); "" !== a.oScroll.sX || "" !== a.oScroll.sY ? alert("FixedHeader 2 is not supported with DataTables' scrolling mode at this time") :
(c.nTable = a.nTable, a.aoDrawCallback.unshift({ fn: function () { FixedHeader.fnMeasure(); d._fnUpdateClones.call(d); d._fnUpdatePositions.call(d) }, sName: "FixedHeader" }), c.bFooter = 0 < e(">tfoot", c.nTable).length ? !0 : !1, c.oSides.top && c.aoCache.push(d._fnCloneTable("fixedHeader", "FixedHeader_Header", d._fnCloneThead)), c.oSides.bottom && c.aoCache.push(d._fnCloneTable("fixedFooter", "FixedHeader_Footer", d._fnCloneTfoot)), c.oSides.left && c.aoCache.push(d._fnCloneTable("fixedLeft", "FixedHeader_Left", d._fnCloneTLeft, c.oSides.left)),
c.oSides.right && c.aoCache.push(d._fnCloneTable("fixedRight", "FixedHeader_Right", d._fnCloneTRight, c.oSides.right)), FixedHeader.afnScroll.push(function () { d._fnUpdatePositions.call(d) }), e(j).resize(function () { FixedHeader.fnMeasure(); d._fnUpdateClones.call(d); d._fnUpdatePositions.call(d) }), e(c.nTable).on("column-reorder.dt", function () { FixedHeader.fnMeasure(); d._fnUpdateClones(!0); d._fnUpdatePositions() }).on("column-visibility.dt", function () { FixedHeader.fnMeasure(); d._fnUpdateClones(!0); d._fnUpdatePositions() }),
FixedHeader.fnMeasure(), d._fnUpdateClones(), d._fnUpdatePositions(), c.bInitComplete = !0)
        }, fnInitSettings: function (a, b) {
            if (b !== h && (b.top !== h && (a.oSides.top = b.top), b.bottom !== h && (a.oSides.bottom = b.bottom), "boolean" == typeof b.left ? a.oSides.left = b.left ? 1 : 0 : b.left !== h && (a.oSides.left = b.left), "boolean" == typeof b.right ? a.oSides.right = b.right ? 1 : 0 : b.right !== h && (a.oSides.right = b.right), b.zTop !== h && (a.oZIndexes.top = b.zTop), b.zBottom !== h && (a.oZIndexes.bottom = b.zBottom), b.zLeft !== h && (a.oZIndexes.left = b.zLeft), b.zRight !==
h && (a.oZIndexes.right = b.zRight), b.offsetTop !== h && (a.oOffset.top = b.offsetTop), b.alwaysCloneTop !== h && (a.oCloneOnDraw.top = b.alwaysCloneTop), b.alwaysCloneBottom !== h && (a.oCloneOnDraw.bottom = b.alwaysCloneBottom), b.alwaysCloneLeft !== h && (a.oCloneOnDraw.left = b.alwaysCloneLeft), b.alwaysCloneRight !== h)) a.oCloneOnDraw.right = b.alwaysCloneRight
        }, _fnCloneTable: function (a, b, c, d) {
            var f = this.fnGetSettings(), g; "absolute" != e(f.nTable.parentNode).css("position") && (f.nTable.parentNode.style.position = "relative"); g = f.nTable.cloneNode(!1);
            g.removeAttribute("id"); var i = k.createElement("div"); i.style.position = "absolute"; i.style.top = "0px"; i.style.left = "0px"; i.className += " FixedHeader_Cloned " + a + " " + b; "fixedHeader" == a && (i.style.zIndex = f.oZIndexes.top); "fixedFooter" == a && (i.style.zIndex = f.oZIndexes.bottom); "fixedLeft" == a ? i.style.zIndex = f.oZIndexes.left : "fixedRight" == a && (i.style.zIndex = f.oZIndexes.right); g.style.margin = "0"; i.appendChild(g); k.body.appendChild(i); return { nNode: g, nWrapper: i, sType: a, sPosition: "", sTop: "", sLeft: "", fnClone: c, iCells: d}
        },
            _fnMeasure: function () { var a = this.fnGetSettings(), b = a.oMes, c = e(a.nTable), d = c.offset(), f = this._fnSumScroll(a.nTable.parentNode, "scrollTop"); this._fnSumScroll(a.nTable.parentNode, "scrollLeft"); b.iTableWidth = c.outerWidth(); b.iTableHeight = c.outerHeight(); b.iTableLeft = d.left + a.nTable.parentNode.scrollLeft; b.iTableTop = d.top + f; b.iTableRight = b.iTableLeft + b.iTableWidth; b.iTableRight = FixedHeader.oDoc.iWidth - b.iTableLeft - b.iTableWidth; b.iTableBottom = FixedHeader.oDoc.iHeight - b.iTableTop - b.iTableHeight }, _fnSumScroll: function (a,
b) { for (var c = a[b]; (a = a.parentNode) && !("HTML" == a.nodeName || "BODY" == a.nodeName); ) c = a[b]; return c }, _fnUpdatePositions: function () { var a = this.fnGetSettings(); this._fnMeasure(); for (var b = 0, c = a.aoCache.length; b < c; b++) "fixedHeader" == a.aoCache[b].sType ? this._fnScrollFixedHeader(a.aoCache[b]) : "fixedFooter" == a.aoCache[b].sType ? this._fnScrollFixedFooter(a.aoCache[b]) : "fixedLeft" == a.aoCache[b].sType ? this._fnScrollHorizontalLeft(a.aoCache[b]) : this._fnScrollHorizontalRight(a.aoCache[b]) }, _fnUpdateClones: function (a) {
    var b =
this.fnGetSettings(); a && (b.bInitComplete = !1); for (var c = 0, d = b.aoCache.length; c < d; c++) b.aoCache[c].fnClone.call(this, b.aoCache[c]); a && (b.bInitComplete = !0)
}, _fnScrollHorizontalRight: function (a) {
    var b = this.fnGetSettings().oMes, c = FixedHeader.oWin, d = FixedHeader.oDoc, f = a.nWrapper, g = e(f).outerWidth(); c.iScrollRight < b.iTableRight ? (this._fnUpdateCache(a, "sPosition", "absolute", "position", f.style), this._fnUpdateCache(a, "sTop", b.iTableTop + "px", "top", f.style), this._fnUpdateCache(a, "sLeft", b.iTableLeft + b.iTableWidth -
g + "px", "left", f.style)) : b.iTableLeft < d.iWidth - c.iScrollRight - g ? (this._fnUpdateCache(a, "sPosition", "fixed", "position", f.style), this._fnUpdateCache(a, "sTop", b.iTableTop - c.iScrollTop + "px", "top", f.style), this._fnUpdateCache(a, "sLeft", c.iWidth - g + "px", "left", f.style)) : (this._fnUpdateCache(a, "sPosition", "absolute", "position", f.style), this._fnUpdateCache(a, "sTop", b.iTableTop + "px", "top", f.style), this._fnUpdateCache(a, "sLeft", b.iTableLeft + "px", "left", f.style))
}, _fnScrollHorizontalLeft: function (a) {
    var b = this.fnGetSettings().oMes,
c = FixedHeader.oWin, d = a.nWrapper, f = e(d).outerWidth(); c.iScrollLeft < b.iTableLeft ? (this._fnUpdateCache(a, "sPosition", "absolute", "position", d.style), this._fnUpdateCache(a, "sTop", b.iTableTop + "px", "top", d.style), this._fnUpdateCache(a, "sLeft", b.iTableLeft + "px", "left", d.style)) : c.iScrollLeft < b.iTableLeft + b.iTableWidth - f ? (this._fnUpdateCache(a, "sPosition", "fixed", "position", d.style), this._fnUpdateCache(a, "sTop", b.iTableTop - c.iScrollTop + "px", "top", d.style), this._fnUpdateCache(a, "sLeft", "0px", "left", d.style)) :
(this._fnUpdateCache(a, "sPosition", "absolute", "position", d.style), this._fnUpdateCache(a, "sTop", b.iTableTop + "px", "top", d.style), this._fnUpdateCache(a, "sLeft", b.iTableLeft + b.iTableWidth - f + "px", "left", d.style))
}, _fnScrollFixedFooter: function (a) {
    var b = this.fnGetSettings(), c = b.oMes, d = FixedHeader.oWin, f = a.nWrapper, b = e("thead", b.nTable).outerHeight(), g = e(f).outerHeight(); d.iScrollBottom < c.iTableBottom ? (this._fnUpdateCache(a, "sPosition", "absolute", "position", f.style), this._fnUpdateCache(a, "sTop", c.iTableTop +
c.iTableHeight - g + "px", "top", f.style), this._fnUpdateCache(a, "sLeft", c.iTableLeft + "px", "left", f.style)) : d.iScrollBottom < c.iTableBottom + c.iTableHeight - g - b ? (this._fnUpdateCache(a, "sPosition", "fixed", "position", f.style), this._fnUpdateCache(a, "sTop", d.iHeight - g + "px", "top", f.style), this._fnUpdateCache(a, "sLeft", c.iTableLeft - d.iScrollLeft + "px", "left", f.style)) : (this._fnUpdateCache(a, "sPosition", "absolute", "position", f.style), this._fnUpdateCache(a, "sTop", c.iTableTop + g + "px", "top", f.style), this._fnUpdateCache(a,
"sLeft", c.iTableLeft + "px", "left", f.style))
}, _fnScrollFixedHeader: function (a) {
    for (var b = this.fnGetSettings(), c = b.oMes, d = FixedHeader.oWin, e = a.nWrapper, g = 0, i = b.nTable.getElementsByTagName("tbody"), h = 0; h < i.length; ++h) g += i[h].offsetHeight; c.iTableTop > d.iScrollTop + b.oOffset.top ? (this._fnUpdateCache(a, "sPosition", "absolute", "position", e.style), this._fnUpdateCache(a, "sTop", c.iTableTop + "px", "top", e.style), this._fnUpdateCache(a, "sLeft", c.iTableLeft + "px", "left", e.style)) : d.iScrollTop + b.oOffset.top > c.iTableTop +
g ? (this._fnUpdateCache(a, "sPosition", "absolute", "position", e.style), this._fnUpdateCache(a, "sTop", c.iTableTop + g + "px", "top", e.style), this._fnUpdateCache(a, "sLeft", c.iTableLeft + "px", "left", e.style)) : (this._fnUpdateCache(a, "sPosition", "fixed", "position", e.style), this._fnUpdateCache(a, "sTop", b.oOffset.top + "px", "top", e.style), this._fnUpdateCache(a, "sLeft", c.iTableLeft - d.iScrollLeft + "px", "left", e.style))
}, _fnUpdateCache: function (a, b, c, d, e) { a[b] != c && (e[d] = c, a[b] = c) }, _fnClassUpdate: function (a, b) {
    var c = this;
    if ("TR" === a.nodeName.toUpperCase() || "TH" === a.nodeName.toUpperCase() || "TD" === a.nodeName.toUpperCase() || "SPAN" === a.nodeName.toUpperCase()) b.className = a.className; e(a).children().each(function (d) { c._fnClassUpdate(e(a).children()[d], e(b).children()[d]) })
}, _fnCloneThead: function (a) {
    var b = this.fnGetSettings(), c = a.nNode; if (b.bInitComplete && !b.oCloneOnDraw.top) this._fnClassUpdate(e("thead", b.nTable)[0], e("thead", c)[0]); else {
        var d = e(b.nTable).outerWidth(); a.nWrapper.style.width = d + "px"; for (c.style.width = d +
"px"; 0 < c.childNodes.length; ) e("thead th", c).unbind("click"), c.removeChild(c.childNodes[0]); a = e("thead", b.nTable).clone(!0)[0]; c.appendChild(a); var f = [], g = []; e("thead>tr th", b.nTable).each(function () { f.push(e(this).width()) }); e("thead>tr td", b.nTable).each(function () { g.push(e(this).width()) }); e("thead>tr th", b.nTable).each(function (a) { e("thead>tr th:eq(" + a + ")", c).width(f[a]); e(this).width(f[a]) }); e("thead>tr td", b.nTable).each(function (a) { e("thead>tr td:eq(" + a + ")", c).width(g[a]); e(this).width(g[a]) });
        e("th.sorting, th.sorting_desc, th.sorting_asc", c).bind("click", function () { this.blur() })
    } 
}, _fnCloneTfoot: function (a) {
    var b = this.fnGetSettings(), c = a.nNode; for (a.nWrapper.style.width = e(b.nTable).outerWidth() + "px"; 0 < c.childNodes.length; ) c.removeChild(c.childNodes[0]); a = e("tfoot", b.nTable).clone(!0)[0]; c.appendChild(a); e("tfoot:eq(0)>tr th", b.nTable).each(function (a) { e("tfoot:eq(0)>tr th:eq(" + a + ")", c).width(e(this).width()) }); e("tfoot:eq(0)>tr td", b.nTable).each(function (a) {
        e("tfoot:eq(0)>tr td:eq(" +
a + ")", c).width(e(this).width())
    })
}, _fnCloneTLeft: function (a) {
    for (var b = this.fnGetSettings(), c = a.nNode, d = e("tbody", b.nTable)[0]; 0 < c.childNodes.length; ) c.removeChild(c.childNodes[0]); c.appendChild(e("thead", b.nTable).clone(!0)[0]); c.appendChild(e("tbody", b.nTable).clone(!0)[0]); b.bFooter && c.appendChild(e("tfoot", b.nTable).clone(!0)[0]); var f = "gt(" + (a.iCells - 1) + ")"; e("thead tr", c).each(function () { e("th:" + f, this).remove() }); e("tfoot tr", c).each(function () { e("th:" + f, this).remove() }); e("tbody tr", c).each(function () {
        e("td:" +
f, this).remove()
    }); this.fnEqualiseHeights("thead", d.parentNode, c); this.fnEqualiseHeights("tbody", d.parentNode, c); this.fnEqualiseHeights("tfoot", d.parentNode, c); for (var g = d = 0; g < a.iCells; g++) d += e("thead tr th:eq(" + g + ")", b.nTable).outerWidth(); c.style.width = d + "px"; a.nWrapper.style.width = d + "px"
}, _fnCloneTRight: function (a) {
    for (var b = this.fnGetSettings(), c = e("tbody", b.nTable)[0], d = a.nNode, f = e("tbody tr:eq(0) td", b.nTable).length; 0 < d.childNodes.length; ) d.removeChild(d.childNodes[0]); d.appendChild(e("thead",
b.nTable).clone(!0)[0]); d.appendChild(e("tbody", b.nTable).clone(!0)[0]); b.bFooter && d.appendChild(e("tfoot", b.nTable).clone(!0)[0]); e("thead tr th:lt(" + (f - a.iCells) + ")", d).remove(); e("tfoot tr th:lt(" + (f - a.iCells) + ")", d).remove(); e("tbody tr", d).each(function () { e("td:lt(" + (f - a.iCells) + ")", this).remove() }); this.fnEqualiseHeights("thead", c.parentNode, d); this.fnEqualiseHeights("tbody", c.parentNode, d); this.fnEqualiseHeights("tfoot", c.parentNode, d); for (var g = c = 0; g < a.iCells; g++) c += e("thead tr th:eq(" + (f -
1 - g) + ")", b.nTable).outerWidth(); d.style.width = c + "px"; a.nWrapper.style.width = c + "px"
}, fnEqualiseHeights: function (a, b, c) { var d = e(a + " tr", b), f; e(a + " tr", c).each(function (a) { f = d.eq(a).css("height"); "Microsoft Internet Explorer" == navigator.appName && (f = parseInt(f, 10) + 1); e(this).css("height", f); d.eq(a).css("height", f) }) } 
        }; FixedHeader.oWin = { iScrollTop: 0, iScrollRight: 0, iScrollBottom: 0, iScrollLeft: 0, iHeight: 0, iWidth: 0 }; FixedHeader.oDoc = { iHeight: 0, iWidth: 0 }; FixedHeader.afnScroll = []; FixedHeader.fnMeasure = function () {
            var a =
e(j), b = e(k), c = FixedHeader.oWin, d = FixedHeader.oDoc; d.iHeight = b.height(); d.iWidth = b.width(); c.iHeight = a.height(); c.iWidth = a.width(); c.iScrollTop = a.scrollTop(); c.iScrollLeft = a.scrollLeft(); c.iScrollRight = d.iWidth - c.iScrollLeft - c.iWidth; c.iScrollBottom = d.iHeight - c.iScrollTop - c.iHeight
        }; FixedHeader.version = "2.1.2"; e(j).scroll(function () { FixedHeader.fnMeasure(); for (var a = 0, b = FixedHeader.afnScroll.length; a < b; a++) FixedHeader.afnScroll[a]() }); e.fn.dataTable.FixedHeader = FixedHeader; return e.fn.DataTable.FixedHeader =
FixedHeader
    }; "function" === typeof define && define.amd ? define(["jquery", "datatables"], l) : "object" === typeof exports ? l(require("jquery"), require("datatables")) : jQuery && !jQuery.fn.dataTable.FixedHeader && l(jQuery, jQuery.fn.dataTable)
})(window, document);